import { render, staticRenderFns } from "./PromoTile.vue?vue&type=template&id=55ee0a02&scoped=true&"
import script from "./PromoTile.vue?vue&type=script&lang=js&"
export * from "./PromoTile.vue?vue&type=script&lang=js&"
import style0 from "./PromoTile.vue?vue&type=style&index=0&id=55ee0a02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ee0a02",
  null
  
)

export default component.exports